import { StyleSheet } from '@react-pdf/renderer';

export const footerStyle = StyleSheet.create({
    container: {
        position: 'absolute',
        bottom: 32,
        left: 32,
        right: 32,
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'flex-end',
        paddingTop: 16,
        borderTopWidth: 1,
        borderTopColor: '#E4EBFB',
        borderTopStyle: 'solid',
    },
    leftSection: {
        flex: 1,
    },
    organizationName: {
        left: 20,
        fontSize: 12,
        color: '#676F80',
    },
    rightSection: {
        flex: 1,
        alignItems: 'flex-end',
        gap: 4,
    },
    infoText: {
        fontSize: 10,
        color: '#6c757d',
    },
});
